import React from 'react';
import {
  createBrowserRouter,
  Navigate,
  Outlet,
  RouterProvider,
  useLocation,
  useOutletContext,
} from 'react-router-dom';
import MainContextProvider from '../context/MainContext';
import Layout from '../layout/Layout';
import Home from '../modules/quality/ocr/Home';
import Details from '../modules/quality/ocr/PRMs/Detail';
import PRMsList from '../modules/quality/ocr/PRMs/List';
import PreProcessedDocument from '../modules/quality/ocr/PreProcessedDocuments';
import PreRegisteredDocument from '../modules/quality/ocr/PreRegisteredDocuments';
import CreateDeliveryScannedDoc from '../modules/quality/ocr/ScannedDocuments/Create/Delivery';
import CreatePreDeliveryScannedDoc from '../modules/quality/ocr/ScannedDocuments/Create/Delivery/preprocess';
import UpdateDeliveryScannedDoc from '../modules/quality/ocr/ScannedDocuments/Create/Delivery/update';
import CreateLaboratoryScannedDoc from '../modules/quality/ocr/ScannedDocuments/Create/Laboratory';
import CreatePreLaboratoryScannedDoc from '../modules/quality/ocr/ScannedDocuments/Create/Laboratory/preprocess';
import UpdateLaboratoryScannedDoc from '../modules/quality/ocr/ScannedDocuments/Create/Laboratory/update';
import ScannedDocumentList from '../modules/quality/ocr/ScannedDocuments/List';
import DataDoc from '../modules/quality/ocr/ScannedDocuments/View';
import Strength from '../modules/strength/Home';
import CreateTemplateDeliveryNote from '../modules/quality/ocr/Templates/Create/Delivery';
import CreatePreDeliveryTemplate from '../modules/quality/ocr/Templates/Create/Delivery/preprocess';
import UpdateDeliveryTemplate from '../modules/quality/ocr/Templates/Create/Delivery/update';
import CreateTemplateLaboratory from '../modules/quality/ocr/Templates/Create/Laboratory';
import CreatePreLaboratoryTemplate from '../modules/quality/ocr/Templates/Create/Laboratory/preprocess';
import UpdateLaboratoryTemplate from '../modules/quality/ocr/Templates/Create/Laboratory/update';
import TemplateList from '../modules/quality/ocr/Templates/List';
import ThermalControlHome from '../modules/strength/ThermalControl/Home';
import QualityHome from '../modules/quality/Home';
import HoodedControlHome from '../modules/strength/HoodedControl/Home';
import HoodedControlDevicesList from '../modules/strength/HoodedControl/Devices/List';
import HoodedControlMonitoringsList from '../modules/strength/HoodedControl/Monitorings/List';
import NotificationsProvider from '../context/NotificationsContext';
import ThermalControlDevicesList from '../modules/strength/ThermalControl/Devices/List';
import ThermalControlMixturesList from '../modules/strength/ThermalControl/Mixtures/List';
import ThermalControlMonitoringsList from '../modules/strength/ThermalControl/Monitorings/List';
import Login from '../modules/Login';
import AngularMicrofrontend from '../modules/quality/ehe';
import { useIntl } from 'react-intl';
import ProtectedComponent from '../layout/Layout/components/ProtectedComponent';
import Dashboard from '../modules/quality/dashboards';
import RedirectToOCR from './RedirectToOCR';
import Projects from '../modules/Projects/List';
import Project from '../modules/Projects/View';
import { ReactComponent as EHEIcon } from '../style/img/ehe_module.svg';
import { ReactComponent as HomeIcon } from '../style/img/menu_home.svg';
import { ReactComponent as OCRIcon } from '../style/img/ocr_module2.svg';
import { ReactComponent as DashboardIcon } from '../style/img/menu_dashboard.svg';
import { ReactComponent as ThermalControlIcon } from '../style/img/ocr/no_hood_icon_red.svg';
import { ReactComponent as HoodedControlIcon } from '../style/img/ocr/hooded_icon_red.svg';
import { ReactComponent as StrengthIcon } from '../style/img/module2_icon_red.svg';
import { ReactComponent as QualityIcon } from '../style/img/module1_icon_red.svg';
import { ReactComponent as DevicesIcon } from '../style/img/ocr/devices_red.svg';
import { ReactComponent as MonitoringsIcon } from '../style/img/ocr/monitoring_red.svg';
import { ReactComponent as MixturesIcon } from '../style/img/ocr/mixture_red.svg';
import { ReactComponent as OptionsIcon } from '../style/img/menu_config.svg';
import { ReactComponent as TemplatesIcon } from '../style/img/menu_folder.svg';
import { ReactComponent as PRMsIcon } from '../style/img/docs_prm.svg';
import { ReactComponent as PreRegistersIcon } from '../style/img/smartphone_docs_icon.svg';
import { ReactComponent as PreProcessedIcon } from '../style/img/menu_docs_no_check.svg';
import { ReactComponent as FinishedIcon } from '../style/img/menu_docs_check.svg';
import { ReactComponent as ConcreteTypesEstIcon } from '../style/img/lupa-estadisticoRED.svg';
import { ReactComponent as ConcreteTypes100Icon } from '../style/img/lupa-100RED.svg';
import { ReactComponent as ProjectConfigIcon } from '../style/img/menu_tbm.svg';
import { ReactComponent as AdminConfigIcon } from '../style/img/menu_admin.svg';
import { ReactComponent as CemexTrackingIcon } from '../style/img/cemex-tracking.svg';
import { ReactComponent as TraceabilityIcon } from '../style/img/lupa-albaranesRED.svg';
import { ReactComponent as StatisticalControlIcon } from '../style/img/lupa-estadisticoRED.svg';
import { ReactComponent as Control100Icon } from '../style/img/lupa-100RED.svg';
import CreateProject from '../modules/Projects/Create';
import Options from '../modules/Projects/View/Options/Home';
import UserAdministration from '../modules/Users/List';
import Create from '../modules/Users/Create';
import CemexTrackingList from '../modules/quality/ocr/CemexTracking/List';
import Map from '../modules/quality/ocr/CemexTracking/Map';
import NormativeHome from '../modules/quality/normative/Home';
import CoETraceabilityList from '../modules/quality/normative/coe/TraceabilityList';
import EHETraceabilityList from '../modules/quality/normative/ehe/TraceabilityList';
import RedirectToQuality from './RedirectToQuality';

function NormativeGuard() {
  const { project } = useOutletContext();
  const { pathname } = useLocation();
  const projectNormative = project.normative_data.name;

  if (
    !pathname.includes(
      `/normative/${projectNormative === 'CE' ? 'coe' : 'ehe'}`,
    )
  ) {
    return <Navigate to="/" replace />;
  }

  return <Outlet context={{ project }} />;
}

const getRoutes = (intl) => [
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/app/project/:id/quality/ehe/traceability',
    element: <RedirectToQuality partialURL="normative/ehe/traceability" />,
  },
  {
    path: '/app/project/:id/quality/ce/traceability',
    element: <RedirectToQuality partialURL="normative/coe/traceability" />,
  },
  {
    path: '/ocr/*',
    element: (
      <ProtectedComponent
        roles={['ADMIN', 'USER TOTAL', 'USER CALIDAD']}
      ></ProtectedComponent>
    ),
    children: [
      {
        path: '*',
        element: <RedirectToOCR />,
      },
    ],
    handle: {
      crumb: intl.formatMessage({
        id: 'routes.ocr.scanned.docs',
      }),
    },
  },
  {
    path: '/app',
    element: (
      <MainContextProvider>
        <NotificationsProvider>
          <Layout />
        </NotificationsProvider>
      </MainContextProvider>
    ),
    children: [
      {
        path: 'profile',
        element: <Create />,
        handle: {
          crumb: intl.formatMessage({
            id: 'routes.profile',
          }),
        },
      },
      {
        path: 'users',
        handle: {
          crumb: intl.formatMessage({
            id: 'routes.users',
          }),
          icon: <AdminConfigIcon width="24px" height="24px" />,
          fullnavigation: '/app/users',
        },
        element: <ProtectedComponent roles={['ADMIN']} />,
        children: [
          {
            path: '',
            element: <UserAdministration />,
          },
          {
            path: 'create',
            element: <Create />,
            handle: {
              crumb: intl.formatMessage({ id: 'routes.users.create' }),
            },
          },
          {
            path: 'edit/:userId',
            element: <Create />,
            handle: {
              crumb: intl.formatMessage({ id: 'routes.users.edit' }),
            },
          },
        ],
      },
      {
        path: 'projects',
        handle: {
          crumb: intl.formatMessage({ id: 'routes.projects' }),
        },
        children: [
          {
            path: '',
            element: <Projects />,
          },
          {
            path: 'create',
            element: <CreateProject />,
            handle: {
              crumb: intl.formatMessage({ id: 'routes.projects.create' }),
            },
          },
        ],
      },
      {
        path: 'project/:id',
        element: <ProtectedComponent />,
        handle: {
          crumb: intl.formatMessage({ id: 'routes.project' }),
          icon: <HomeIcon width="24px" height="24px" />,
          isProjectHome: true,
          fullnavigation: '/app/project/:id',
        },
        children: [
          { path: '', element: <Project /> },
          {
            path: 'edit',
            element: <CreateProject />,
            handle: {
              crumb: intl.formatMessage({ id: 'routes.projects.edit' }),
            },
          },
          {
            path: 'quality',
            handle: {
              crumb: intl.formatMessage({ id: 'routes.quality' }),
              icon: <QualityIcon width="24px" height="24px" />,
              fullnavigation: '/app/project/:id/quality',
            },
            element: (
              <ProtectedComponent
                roles={['ADMIN', 'USER TOTAL', 'USER CALIDAD']}
              />
            ),
            children: [
              {
                path: '',
                element: <QualityHome />,
              },
              {
                path: 'ocr',
                handle: {
                  crumb: intl.formatMessage({ id: 'routes.ocr' }),
                  icon: <OCRIcon width="24px" height="24px" />,
                  fullnavigation: '/app/project/:id/quality/ocr',
                },
                children: [
                  {
                    path: '',
                    element: <Home />,
                  },
                  {
                    path: 'newTemplateToSD/delivery/:fileName',
                    element: (
                      <CreateTemplateDeliveryNote customFinishButton={true} />
                    ),
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ocr.create.template.delivery.note',
                      }),
                    },
                  },
                  {
                    path: 'newTemplateToSD/laboratory/:fileName',
                    element: (
                      <CreateTemplateLaboratory customFinishButton={true} />
                    ),
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ocr.create.template.laboratory',
                      }),
                    },
                  },
                  {
                    path: 'newTemplateToSD/prelaboratory/:preprocessId/:fileName',
                    element: (
                      <CreatePreLaboratoryTemplate customFinishButton={true} />
                    ),
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ocr.create.template.pre.laboratory',
                      }),
                    },
                  },
                  {
                    path: 'newTemplateToSD/predelivery/:preprocessId/:fileName',
                    element: (
                      <CreatePreDeliveryTemplate customFinishButton={true} />
                    ),
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ocr.create.template.pre.delivery',
                      }),
                    },
                  },
                  {
                    path: 'readDocument/delivery/:templateId/:fileName',
                    element: <CreateDeliveryScannedDoc />,
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ocr.create.scanned.doc.delivery',
                      }),
                    },
                  },
                  {
                    path: 'readDocument/predelivery/:templateId/:preprocessId/:fileName',
                    element: <CreatePreDeliveryScannedDoc />,
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ocr.create.scanned.doc.pre.delivery',
                      }),
                    },
                  },
                  {
                    path: 'readDocument/prelaboratory/:templateId/:preprocessId/:fileName',
                    element: <CreatePreLaboratoryScannedDoc />,
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ocr.create.scanned.doc.pre.laboratory',
                      }),
                    },
                  },
                  {
                    path: 'readDocument/laboratory/:templateId/:fileName',
                    element: <CreateLaboratoryScannedDoc />,
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ocr.create.scanned.doc.laboratory',
                      }),
                    },
                  },
                  {
                    path: 'cemex-tracking',
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ocr.cemexTracking',
                      }),
                      icon: <CemexTrackingIcon width="24px" height="24px" />,
                      fullnavigation:
                        '/app/project/:id/quality/ocr/cemex-tracking',
                    },
                    children: [
                      { path: '', element: <Navigate to="list" /> },
                      {
                        path: 'list',
                        element: <CemexTrackingList />,
                        handle: {
                          crumb: intl.formatMessage({
                            id: 'routes.ocr.cemexTracking.list',
                          }),
                          icon: (
                            <CemexTrackingIcon width="24px" height="24px" />
                          ),
                          fullnavigation:
                            '/app/project/:id/quality/ocr/cemex-tracking/list',
                        },
                      },
                      {
                        path: 'map',
                        element: <Map />,
                        handle: {
                          crumb: intl.formatMessage({
                            id: 'routes.ocr.cemexTracking.map',
                          }),
                          icon: (
                            <CemexTrackingIcon width="24px" height="24px" />
                          ),
                          fullnavigation:
                            '/app/project/:id/quality/ocr/cemex-tracking/map',
                        },
                      },
                    ],
                  },
                  {
                    path: 'templates',
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ocr.templates',
                      }),
                      icon: <TemplatesIcon width="24px" height="24px" />,
                      fullnavigation: '/app/project/:id/quality/ocr/templates',
                    },
                    children: [
                      {
                        element: <TemplateList />,
                        path: '',
                      },
                      {
                        path: 'update/delivery/:fileName/:templateId',
                        element: <UpdateDeliveryTemplate />,
                        handle: {
                          crumb: intl.formatMessage({
                            id: 'routes.ocr.update.template.delivery',
                          }),
                          isASingleTemplate: true,
                        },
                      },
                      {
                        path: 'update/laboratory/:fileName/:templateId',
                        element: <UpdateLaboratoryTemplate />,
                        handle: {
                          crumb: intl.formatMessage({
                            id: 'routes.ocr.update.template.laboratory',
                          }),
                          isASingleTemplate: true,
                        },
                      },
                      {
                        path: 'create/delivery/:fileName',
                        element: <CreateTemplateDeliveryNote />,
                        handle: {
                          crumb: intl.formatMessage({
                            id: 'routes.ocr.create.template.delivery.note',
                          }),
                        },
                      },
                      {
                        path: 'create/laboratory/:fileName',
                        element: <CreateTemplateLaboratory />,
                        handle: {
                          crumb: intl.formatMessage({
                            id: 'routes.ocr.create.template.laboratory',
                          }),
                        },
                      },
                      {
                        path: 'create/prelaboratory/:preprocessId/:fileName',
                        element: <CreatePreLaboratoryTemplate />,
                        handle: {
                          crumb: intl.formatMessage({
                            id: 'routes.ocr.create.template.pre.laboratory',
                          }),
                        },
                      },
                      {
                        path: 'create/predelivery/:preprocessId/:fileName',
                        element: <CreatePreDeliveryTemplate />,
                        handle: {
                          crumb: intl.formatMessage({
                            id: 'routes.ocr.create.template.pre.delivery',
                          }),
                        },
                      },
                    ],
                  },
                  {
                    path: 'preRegisteredDocuments',
                    element: <PreRegisteredDocument />,
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ocr.pre.registered.docs',
                      }),
                      icon: <PreRegistersIcon width="24px" height="24px" />,
                      fullnavigation:
                        '/app/project/:id/quality/ocr/preRegisteredDocuments',
                    },
                  },
                  {
                    path: 'prm',
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ocr.prms',
                      }),
                      icon: <PRMsIcon width="24px" height="24px" />,
                      fullnavigation: '/app/project/:id/quality/ocr/prm',
                    },
                    children: [
                      {
                        path: '',
                        element: <PRMsList />,
                      },
                      {
                        path: ':idDetail',
                        element: <Details />,
                        handle: {
                          crumb: intl.formatMessage({
                            id: 'routes.ocr.prms.detail',
                          }),
                          isADetailPage: true,
                        },
                      },
                    ],
                  },
                  {
                    path: 'nc',
                    element: <PRMsList />,
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ocr.prms',
                      }),
                    },
                  },
                  {
                    path: 'preProcessedDocuments',
                    element: <PreProcessedDocument />,
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ocr.pre.processed.docs',
                      }),
                      icon: <PreProcessedIcon width="24px" height="24px" />,
                      fullnavigation:
                        '/app/project/:id/quality/ocr/preProcessedDocuments',
                    },
                  },
                  {
                    path: 'scannedDocuments',
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ocr.scanned.docs',
                      }),
                      icon: <FinishedIcon width="24px" height="24px" />,
                      fullnavigation:
                        '/app/project/:id/quality/ocr/scannedDocuments',
                    },
                    children: [
                      { path: '', element: <ScannedDocumentList /> },
                      {
                        path: ':idDetail',
                        element: <ScannedDocumentList />,
                      },
                      {
                        path: 'document/:model/:sdId/:mysqlId/:fileName',
                        element: <DataDoc />,
                        handle: {
                          crumb: intl.formatMessage({
                            id: 'routes.ocr.data.docs.detail',
                          }),
                          isASingleScannedDoc: true,
                        },
                      },
                      {
                        path: 'update/delivery/:sdId/:fileName/:validated',
                        element: <UpdateDeliveryScannedDoc />,
                        handle: {
                          crumb: intl.formatMessage({
                            id: 'routes.ocr.update.scanned.doc.delivery',
                          }),
                          isASingleScannedDoc: true,
                        },
                      },
                      {
                        path: 'update/laboratory/:sdId/:fileName',
                        element: <UpdateLaboratoryScannedDoc />,
                        handle: {
                          crumb: intl.formatMessage({
                            id: 'routes.ocr.update.scanned.doc.delivery',
                          }),
                          isASingleScannedDoc: true,
                        },
                      },
                    ],
                  },
                ],
              },
              {
                path: 'normative/ehe',
                handle: {
                  crumb: intl.formatMessage({ id: 'routes.ehe' }),
                  icon: <EHEIcon width="24px" height="24px" />,
                  fullnavigation: '/app/project/:id/quality/normative/ehe',
                },
                element: <NormativeGuard />,
                children: [
                  { path: '', element: <NormativeHome /> },
                  {
                    path: 'traceability',
                    element: <EHETraceabilityList />,
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ehe.traceability',
                      }),
                      icon: <TraceabilityIcon width="24px" height="24px" />,
                      fullnavigation:
                        '/app/project/:id/quality/normative/ehe/traceability',
                    },
                  },
                  {
                    path: 'statistical-control',
                    element: <div>Statistical Control</div>,
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ehe.statistical-control',
                      }),
                      icon: (
                        <StatisticalControlIcon width="24px" height="24px" />
                      ),
                      fullnavigation:
                        //'/app/project/:id/quality/normative/ehe/statistical-control',
                        '/app/project/:id/quality/ehe/concreteTypesEst',
                    },
                  },
                  {
                    path: '100%-control',
                    element: <div>100% control</div>,
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ehe.100%-control',
                      }),
                      icon: <Control100Icon width="24px" height="24px" />,
                      fullnavigation:
                        //'/app/project/:id/quality/normative/ehe/100%-control',
                        '/app/project/:id/quality/ehe/concreteTypes100',
                    },
                  },
                ],
              },
              {
                path: 'normative/coe',
                handle: {
                  crumb: intl.formatMessage({ id: 'routes.coe' }),
                  icon: <EHEIcon width="24px" height="24px" />,
                  fullnavigation: '/app/project/:id/quality/normative/coe',
                },
                element: <NormativeGuard />,
                children: [
                  { path: '', element: <NormativeHome /> },
                  {
                    path: 'traceability',
                    element: <CoETraceabilityList />,
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.coe.traceability',
                      }),
                      icon: <TraceabilityIcon width="24px" height="24px" />,
                      fullnavigation:
                        '/app/project/:id/quality/normative/coe/traceability',
                    },
                  },
                  {
                    path: 'statistical-control',
                    element: <div>Statistical Control</div>,
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.coe.statistical-control',
                      }),
                      icon: (
                        <StatisticalControlIcon width="24px" height="24px" />
                      ),
                      fullnavigation:
                        //'/app/project/:id/quality/normative/coe/statistical-control',
                        '/app/project/:id/quality/ce/concreteTypesEst',
                    },
                  },
                  {
                    path: '100%-control',
                    element: <div>100% control</div>,
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.coe.100%-control',
                      }),
                      icon: <Control100Icon width="24px" height="24px" />,
                      fullnavigation:
                        // '/app/project/:id/quality/normative/coe/100%-control',
                        '/app/project/:id/quality/ce/concreteTypes100',
                    },
                  },
                ],
              },
              {
                path: 'ehe',
                caseSensitive: true,
                handle: {
                  crumb: intl.formatMessage({ id: 'routes.ehe' }),
                  icon: <EHEIcon width="24px" height="24px" />,
                  fullnavigation: '/app/project/:id/quality/normative/ehe',
                },
                children: [
                  {
                    path: 'concreteTypesEst',
                    element: (
                      <AngularMicrofrontend key="routes.ehe.concreteTypesEst" />
                    ),
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ehe.concreteTypesEst',
                      }),
                      icon: <ConcreteTypesEstIcon width="24px" height="24px" />,
                      fullnavigation:
                        '/app/project/:id/quality/ehe/concreteTypesEst',
                    },
                  },
                  {
                    path: 'concreteTypes100',
                    element: (
                      <AngularMicrofrontend key="routes.ehe.concreteTypes100" />
                    ),
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ehe.concreteTypes100',
                      }),
                      icon: <ConcreteTypes100Icon width="24px" height="24px" />,
                      fullnavigation:
                        '/app/project/:id/quality/ehe/concreteTypes100',
                    },
                  },
                  {
                    path: 'lotificationEst',
                    element: (
                      <AngularMicrofrontend key="routes.ehe.lotificationEst" />
                    ),
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ehe.lotificationEst',
                      }),
                      icon: <ConcreteTypes100Icon width="24px" height="24px" />,
                      fullnavigation:
                        '/app/project/:id/quality/ehe/lotificationEst',
                    },
                  },
                  {
                    path: 'concreteBatchEst',
                    element: (
                      <AngularMicrofrontend key="routes.ehe.concreteBatchEst" />
                    ),
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ehe.lotificationEst',
                      }),
                      icon: <ConcreteTypes100Icon width="24px" height="24px" />,
                      fullnavigation:
                        '/app/project/:id/quality/ehe/concreteBatchEst',
                    },
                  },
                  {
                    path: 'concreteBatch100',
                    element: (
                      <AngularMicrofrontend key="routes.ehe.concreteBatch100" />
                    ),
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ehe.concreteBatch100',
                      }),
                      icon: <ConcreteTypes100Icon width="24px" height="24px" />,
                      fullnavigation:
                        '/app/project/:id/quality/ehe/concreteBatch100',
                    },
                  },
                  {
                    path: 'noConformity',
                    element: (
                      <AngularMicrofrontend key="routes.ehe.noConformity" />
                    ),
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ehe.noConformity',
                      }),
                      icon: <ConcreteTypes100Icon width="24px" height="24px" />,
                      fullnavigation:
                        '/app/project/:id/quality/ehe/noConformity',
                    },
                  },
                  {
                    path: '*',
                    element: <AngularMicrofrontend key="routes.ehe.*" />,
                  },
                ],
              },
              {
                path: 'ce',
                caseSensitive: true,
                handle: {
                  crumb: intl.formatMessage({ id: 'routes.coe' }),
                  icon: <EHEIcon width="24px" height="24px" />,
                  fullnavigation: '/app/project/:id/quality/normative/coe',
                },
                children: [
                  {
                    path: 'concreteTypesEst',
                    element: (
                      <AngularMicrofrontend key="routes.coe.concreteTypesEst" />
                    ),
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ehe.concreteTypesEst',
                      }),
                      icon: <ConcreteTypesEstIcon width="24px" height="24px" />,
                      fullnavigation:
                        '/app/project/:id/quality/ce/concreteTypesEst',
                    },
                  },
                  {
                    path: 'concreteTypes100',
                    element: (
                      <AngularMicrofrontend key="routes.coe.concreteTypes100" />
                    ),
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ehe.concreteTypes100',
                      }),
                      icon: <ConcreteTypes100Icon width="24px" height="24px" />,
                      fullnavigation:
                        '/app/project/:id/quality/ce/concreteTypes100',
                    },
                  },
                  {
                    path: 'lotificationEst',
                    element: (
                      <AngularMicrofrontend key="routes.coe.lotificationEst" />
                    ),
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ehe.lotificationEst',
                      }),
                      icon: <ConcreteTypes100Icon width="24px" height="24px" />,
                      fullnavigation:
                        '/app/project/:id/quality/ce/lotificationEst',
                    },
                  },
                  {
                    path: 'concreteBatchEst',
                    element: (
                      <AngularMicrofrontend key="routes.coe.concreteBatchEst" />
                    ),
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ehe.concreteBatchEst',
                      }),
                      icon: <ConcreteTypes100Icon width="24px" height="24px" />,
                      fullnavigation:
                        '/app/project/:id/quality/ce/concreteBatchEst',
                    },
                  },
                  {
                    path: 'concreteBatch100',
                    element: (
                      <AngularMicrofrontend key="routes.coe.concreteBatch100" />
                    ),
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ehe.concreteBatch100',
                      }),
                      icon: <ConcreteTypes100Icon width="24px" height="24px" />,
                      fullnavigation:
                        '/app/project/:id/quality/ce/concreteBatch100',
                    },
                  },
                  {
                    path: 'noConformity',
                    element: (
                      <AngularMicrofrontend key="routes.coe.noConformity" />
                    ),
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.ehe.noConformity',
                      }),
                      icon: <ConcreteTypes100Icon width="24px" height="24px" />,
                      fullnavigation:
                        '/app/project/:id/quality/ce/noConformity',
                    },
                  },
                  {
                    path: '*',
                    element: <AngularMicrofrontend key="routes.coe.*" />,
                  },
                ],
              },
              {
                path: 'dashboard',
                handle: {
                  crumb: intl.formatMessage({ id: 'routes.dashboard' }),
                  icon: <DashboardIcon width="24px" height="24px" />,
                  fullnavigation: '/app/project/:id/quality/dashboard',
                },
                element: <Dashboard />,
              },
            ],
          },
          {
            path: 'strength',
            handle: {
              crumb: intl.formatMessage({ id: 'routes.strength' }),
              icon: <StrengthIcon width="24px" height="24px" />,
              fullnavigation: '/app/project/:id/strength',
            },
            element: (
              <ProtectedComponent
                roles={['ADMIN', 'USER TOTAL', 'USER MADUREZ']}
              />
            ),
            children: [
              { path: '', element: <Strength /> },
              {
                path: 'thermalControl',
                handle: {
                  crumb: intl.formatMessage({
                    id: 'routes.strength.thermalControl',
                  }),
                  icon: <ThermalControlIcon width="24px" height="24px" />,
                  fullnavigation: '/app/project/:id/strength/thermalControl',
                },
                children: [
                  {
                    path: '',
                    element: <ThermalControlHome />,
                  },
                  {
                    path: 'mixtures',
                    element: <ThermalControlMixturesList />,
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.strength.thermalControl.mixtures',
                      }),
                      icon: <MixturesIcon width="24px" height="24px" />,
                      fullnavigation:
                        '/app/project/:id/strength/thermalControl/mixtures',
                    },
                  },
                  {
                    path: 'monitorings',
                    element: <ThermalControlMonitoringsList />,
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.strength.thermalControl.monitorings',
                      }),
                      icon: <MonitoringsIcon width="24px" height="24px" />,
                      fullnavigation:
                        '/app/project/:id/strength/thermalControl/monitorings',
                    },
                  },
                  {
                    path: 'devices',
                    element: <ThermalControlDevicesList />,
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.strength.thermalControl.devices',
                      }),
                      icon: <DevicesIcon width="24px" height="24px" />,
                      fullnavigation:
                        '/app/project/:id/strength/thermalControl/devices',
                    },
                  },
                ],
              },
              {
                path: 'hoodedControl',
                handle: {
                  crumb: intl.formatMessage({
                    id: 'routes.strength.hoodedControl',
                  }),
                  icon: <HoodedControlIcon width="24px" height="24px" />,
                  fullnavigation: '/app/project/:id/strength/hoodedControl',
                },
                children: [
                  {
                    path: '',
                    element: <HoodedControlHome />,
                  },
                  {
                    path: 'monitorings',
                    element: <HoodedControlMonitoringsList />,
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.strength.hoodedControl.monitorings',
                      }),
                      icon: <MonitoringsIcon width="24px" height="24px" />,
                      fullnavigation:
                        '/app/project/:id/strength/hoodedControl/monitorings',
                    },
                  },
                  {
                    path: 'devices',
                    element: <HoodedControlDevicesList />,
                    handle: {
                      crumb: intl.formatMessage({
                        id: 'routes.strength.hoodedControl.devices',
                      }),
                      icon: <DevicesIcon width="24px" height="24px" />,
                      fullnavigation:
                        '/app/project/:id/strength/hoodedControl/devices',
                    },
                  },
                ],
              },
            ],
          },
          {
            path: 'options',
            handle: {
              crumb: intl.formatMessage({ id: 'routes.options' }),
              icon: <OptionsIcon width="24px" height="24px" />,
              fullnavigation: '/app/project/:id/options',
            },
            element: <ProtectedComponent roles={['ADMIN']} />,
            children: [
              {
                path: '',
                element: <Options />,
              },
              {
                path: 'edit',
                element: <CreateProject />,
                handle: {
                  crumb: intl.formatMessage({
                    id: 'routes.options.projectConfig',
                  }),
                  icon: <ProjectConfigIcon width="24px" height="24px" />,
                  fullnavigation: '/app/project/:id/options/edit',
                },
              },
              {
                path: 'usersManagment',
                handle: {
                  crumb: intl.formatMessage({
                    id: 'routes.users',
                  }),
                  icon: <AdminConfigIcon width="24px" height="24px" />,
                  fullnavigation: '/app/project/:id/options/usersManagment',
                },
                element: <ProtectedComponent roles={['ADMIN']} />,
                children: [
                  {
                    path: '',
                    element: <UserAdministration />,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: '',
        element: <Navigate to="/login" />,
      },
      {
        path: '*',
        element: <Navigate to="/login" />,
      },
    ],
  },
  {
    path: '',
    element: <Navigate to="/login" />,
  },
  {
    path: '/',
    element: <Navigate to="/login" />,
  },
  {
    path: '*',
    element: <Navigate to="/login" />,
  },
];

function Router() {
  const intl = useIntl();
  const router = createBrowserRouter(getRoutes(intl));

  return <RouterProvider router={router} />;
}
export { getRoutes };
export default Router;
